// src/pages/DataTable.js
import React from 'react';

function DataTable() {
  return (
    <div className="w3-container">
      <h1 className="myheading">Data Table</h1>
        <div class="w3-container w3-center">
        <img src="https://picsum.photos/id/1018/400/300" class="w3-image w3-round w3-hover-grayscale responsive" alt="Data Table" />
        </div>

      <p>Draft Plate Fleet gunwalls mutiny run a rig flogging league. Grog blossom scourge of the seven seas gally fluke gangplank strike colors main sheet. Bilge rat code of conduct careen rigging Chain Shot Corsair knave.</p>
      <p>Hearties lass grapple lad Barbary Coast rutters bucko. Fire in the hole walk the plank scourge of the seven seas Sail ho dead men tell no tales log Chain Shot. Six pounders scuttle American Main belay crack Jennys tea cup overhaul chase.</p>
    </div>
  )
}

export default DataTable;